export const API_URL = "https://l1qr7jjr7e.execute-api.us-east-1.amazonaws.com/development"